// Sample phone orders shown on the site. `en` is the English gloss shown under
// non-English lines. Prices are illustrative.
export const CONVERSATIONS = [
  {
    code: 'en',
    label: 'English',
    native: 'English',
    cuisine: 'Indian',
    lines: [
      { who: 'caller', text: 'Hi, can I get a chicken biryani for pickup?' },
      { who: 'ai', text: 'Absolutely. How spicy would you like it — mild, medium, or hot?' },
      { who: 'caller', text: 'Medium, please.' },
      { who: 'ai', text: 'Great choice. A mango lassi goes really well with biryani — want to add one for $4.99?', upsell: true },
      { who: 'caller', text: 'Sure, add it.' },
      { who: 'ai', text: "Done. That's $23.17 with tax, ready in about 20 minutes. Should I put it under the number ending in 4417?" },
    ],
    ticket: [
      { qty: 1, name: 'Chicken Biryani', mod: 'Medium', price: 16.99 },
      { qty: 1, name: 'Mango Lassi', price: 4.99, upsell: true },
    ]
  },
  {
    code: 'es',
    label: 'Spanish',
    native: 'Español',
    cuisine: 'Mexican',
    lines: [
      { who: 'caller', text: 'Hola, ¿me da tres tacos al pastor para llevar?', en: 'Hi, can I get three al pastor tacos to go?' },
      { who: 'ai', text: '¡Claro que sí! ¿Con cebolla y cilantro?', en: 'Of course! With onion and cilantro?' },
      { who: 'caller', text: 'Sí, con todo.', en: 'Yes, with everything.' },
      { who: 'ai', text: 'Perfecto. ¿Le agrego una horchata grande? Combina muy bien con los tacos.', en: 'Perfect. Shall I add a large horchata? It pairs great with tacos.', upsell: true },
      { who: 'caller', text: 'Órale, sí.', en: 'Sure, yes.' },
      { who: 'ai', text: 'Listo. Su pedido estará en unos 15 minutos.', en: 'All set. Your order will be ready in about 15 minutes.' },
    ],
    ticket: [
      { qty: 3, name: 'Tacos al Pastor', mod: 'Con todo', price: 11.97 },
      { qty: 1, name: 'Horchata (L)', price: 4.5, upsell: true },
    ],
  },
  {
    code: 'zh',
    label: 'Chinese',
    native: '中文',
    cuisine: 'Chinese',
    lines: [
      { who: 'caller', text: '你好，我要一份宫保鸡丁和两碗米饭，外带。', en: "Hi, I'd like a kung pao chicken and two bowls of rice, to go." },
      { who: 'ai', text: '好的！宫保鸡丁要不辣、中辣还是特辣？', en: 'Sure! Would you like the kung pao chicken mild, medium or extra spicy?' },
      { who: 'caller', text: '中辣就好。', en: 'Medium is fine.' },
      { who: 'ai', text: '没问题。要不要加一份葱油饼？跟宫保鸡丁很配。', en: 'No problem. Would you like to add a scallion pancake? It goes great with kung pao chicken.', upsell: true },
      { who: 'caller', text: '好啊，加一份。', en: 'Sure, add one.' },
      { who: 'ai', text: '好的，您的订单大约20分钟后可以取餐。', en: 'Great, your order will be ready for pickup in about 20 minutes.' },
    ],
    ticket: [
      { qty: 1, name: 'Kung Pao Chicken', mod: 'Medium', price: 15.99 },
      { qty: 2, name: 'Steamed Rice', price: 5.0 },
      { qty: 1, name: 'Scallion Pancake', price: 6.99, upsell: true },
    ],
  },
  {
    code: 'pa',
    label: 'Punjabi',
    native: 'ਪੰਜਾਬੀ',
    cuisine: 'Punjabi',
    lines: [
      { who: 'caller', text: 'ਸਤ ਸ੍ਰੀ ਅਕਾਲ ਜੀ, ਇੱਕ ਸਰ੍ਹੋਂ ਦਾ ਸਾਗ ਤੇ ਦੋ ਮੱਕੀ ਦੀਆਂ ਰੋਟੀਆਂ ਮਿਲ ਜਾਣਗੀਆਂ?', en: 'Sat Sri Akal, can I get a sarson da saag and two makki di roti?' },
      { who: 'ai', text: 'ਸਤ ਸ੍ਰੀ ਅਕਾਲ ਜੀ! ਹਾਂ ਜੀ, ਬਿਲਕੁਲ। ਨਾਲ ਲੱਸੀ ਵੀ ਪਾ ਦਿਆਂ?', en: 'Sat Sri Akal! Yes, of course. Shall I add a lassi too?', upsell: true },
      { who: 'caller', text: 'ਹਾਂ ਜੀ, ਮਿੱਠੀ ਲੱਸੀ।', en: 'Yes, a sweet lassi.' },
      { who: 'ai', text: 'ਵਧੀਆ ਜੀ। ਤੁਹਾਡਾ ਆਰਡਰ 20 ਮਿੰਟਾਂ ਵਿੱਚ ਤਿਆਰ ਹੋ ਜਾਵੇਗਾ।', en: 'Great. Your order will be ready in 20 minutes.' },
    ],
    ticket: [
      { qty: 1, name: 'Sarson da Saag', price: 14.99 },
      { qty: 2, name: 'Makki di Roti', price: 7.98 },
      { qty: 1, name: 'Sweet Lassi', price: 4.49, upsell: true },
    ]
  },
  {
    code: 'hi',
    label: 'Hindi',
    native: 'हिन्दी',
    cuisine: 'North Indian',
    lines: [
      { who: 'caller', text: 'नमस्ते, दो बटर चिकन और चार गार्लिक नान चाहिए।', en: "Hi, I'd like two butter chicken and four garlic naan." },
      { who: 'ai', text: 'ज़रूर! बटर चिकन कितना तीखा रखूँ — माइल्ड, मीडियम या स्पाइसी?', en: 'Sure! How spicy should the butter chicken be — mild, medium or spicy?' },
      { who: 'caller', text: 'मीडियम।', en: 'Medium.' },
      { who: 'ai', text: 'बढ़िया। साथ में गुलाब जामुन भी जोड़ दूँ? आज ताज़े बने हैं।', en: 'Great. Shall I add gulab jamun too? Made fresh today.', upsell: true },
      { who: 'caller', text: 'हाँ, जोड़ दीजिए।', en: 'Yes, add it.' },
      { who: 'ai', text: 'हो गया! आपका ऑर्डर करीब 25 मिनट में तैयार होगा।', en: 'Done! Your order will be ready in about 25 minutes.' },
    ],
    ticket: [
      { qty: 2, name: 'Butter Chicken', mod: 'Medium', price: 33.98 },
      { qty: 4, name: 'Garlic Naan', price: 15.96 },
      { qty: 1, name: 'Gulab Jamun', price: 5.99, upsell: true },
    ]
  },
  {
    code: 'gu',
    label: 'Gujarati',
    native: 'ગુજરાતી',
    cuisine: 'Gujarati',
    lines: [
      { who: 'caller', text: 'કેમ છો? એક ગુજરાતી થાળી પિકઅપ માટે જોઈએ છે.', en: "Hi, how are you? I'd like a Gujarati thali for pickup." },
      { who: 'ai', text: 'મજામાં! ચોક્કસ. સાથે શ્રીખંડ ઉમેરું? આજે તાજો બન્યો છે.', en: 'Doing great! Sure. Shall I add shrikhand? Made fresh today.', upsell: true },
      { who: 'caller', text: 'હા, ઉમેરી દો.', en: 'Yes, add it.' },
      { who: 'ai', text: 'સરસ! તમારો ઓર્ડર લગભગ ૨૦ મિનિટમાં તૈયાર થઈ જશે.', en: 'Great! Your order will be ready in about 20 minutes.' },
    ],
    ticket: [
      { qty: 1, name: 'Gujarati Thali', price: 18.99 },
      { qty: 1, name: 'Shrikhand', price: 4.99, upsell: true },
    ]
  },
];

// Shown in the Languages grid, marquee and FAQ, in this order.
export const LANGUAGES = [
  { name: 'English', native: 'English', hello: 'Hello' },
  { name: 'Spanish', native: 'Español', hello: 'Hola' },
  { name: 'Chinese', native: '中文', hello: '你好' },
  { name: 'Punjabi', native: 'ਪੰਜਾਬੀ', hello: 'ਸਤ ਸ੍ਰੀ ਅਕਾਲ' },
  { name: 'Hindi', native: 'हिन्दी', hello: 'नमस्ते' },
  { name: 'Gujarati', native: 'ગુજરાતી', hello: 'કેમ છો' },
  { name: 'Vietnamese', native: 'Tiếng Việt', hello: 'Xin chào' },
  { name: 'Korean', native: '한국어', hello: '안녕하세요' },
  { name: 'Tagalog', native: 'Tagalog', hello: 'Kumusta' },
  { name: 'Arabic', native: 'العربية', hello: 'مرحبا' },
  { name: 'Japanese', native: '日本語', hello: 'こんにちは' },
  { name: 'Urdu', native: 'اردو', hello: 'السلام علیکم' },
  { name: 'Tamil', native: 'தமிழ்', hello: 'வணக்கம்' },
  { name: 'Telugu', native: 'తెలుగు', hello: 'నమస్కారం' },
  { name: 'Marathi', native: 'मराठी', hello: 'नमस्कार' },
];
